import {
  IDominioForm,
  IDominioRegistro,
  IDominioSelect,
} from '../../modules/types/Dominio';
import httpClient from '../httpClient';

const API_BASE = '/api/dominios';

export const getAllDominios = async (): Promise<IDominioRegistro[]> => {
  try {
    const response = await httpClient.get(API_BASE);

    const lista: IDominioRegistro[] = Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];

    // Ordenação corretamente tipada
    return lista.sort(
      (a: IDominioRegistro, b: IDominioRegistro) => (a.id ?? 0) - (b.id ?? 0),
    );
  } catch (error: any) {
    throw new Error('Erro ao obter lista de domínios: ' + error.message);
  }
};

export const getDominioById = async (
  id: string | number,
): Promise<IDominioRegistro> => {
  try {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter Domínio: ' + error.message);
  }
};

export const getDominiosByPaiId = async (
  id: number | string,
): Promise<IDominioRegistro[]> => {
  try {
    const response = await httpClient.get(`${API_BASE}/pai/${id}`);

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error('Erro ao obter lista de domínios: ' + error.message);
  }
};

export const handleCreateDominio = async (form: IDominioForm): Promise<any> => {
  try {
    const response = await httpClient.post(API_BASE, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao criar Domínio: ' + error.message);
  }
};

export const handleUpdateDominio = async (form: IDominioForm): Promise<any> => {
  try {
    const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao atualizar domínio: ' + error.message);
  }
};

export const handleDeleteDominio = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data; // { message }
  } catch (error: any) {
    throw new Error('Erro ao excluir domínio: ' + error.message);
  }
};

export const getDominiosSelect = async (): Promise<IDominioSelect[]> => {
  try {
    const response = await httpClient.get(`${API_BASE}/lista-select`);

    const lista: IDominioSelect[] = Array.isArray(response.data)
      ? response.data
      : [];

    // Ordenação extra (se quiser garantir)
    return lista.sort(
      (a: IDominioSelect, b: IDominioSelect) => (a.ordem ?? 0) - (b.ordem ?? 0),
    );
  } catch (error: any) {
    throw new Error(
      'Erro ao obter lista reduzida de domínios (select): ' + error.message,
    );
  }
};
